import styled from '@emotion/styled';

export const HistoryContainer = styled.section`
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 8rem 0rem;
	gap: 6rem;
`;

export const HistoryDateList = styled.div`
	display: flex; /* 가로 스크롤이 잘 적용되도록 변경 */
	width: 100%;
	height: 5.2rem;
	overflow-x: auto; /* 가로 스크롤 활성화 */
	white-space: nowrap; /* 줄 바꿈 방지 */
	scrollbar-width: none; /* Firefox에서 스크롤바 숨기기 */
	scrollbar-color: #ccc transparent; /* Firefox 스크롤 색상 */
	@media screen and (max-width: 1370px) {
		padding-left: 2rem;
	}
	&::-webkit-scrollbar {
		display: none;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #ccc; /* 스크롤바 색상 */
		border-radius: 3px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}
`;

export const HistoryDate = styled.div`
	flex: 0 0 auto; /* 각 항목이 자동으로 크기 조정되도록 설정 */
	min-width: 12rem; /* 개별 날짜 항목의 최소 너비 설정 */
	max-width: 16.9rem;
	width: 100%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
	background-color: #f1f3f5;
	border-left: 1px solid #dee2e6;
	cursor: pointer;

	&.active {
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
	}

	&:last-of-type {
		border-right: 1px solid #dee2e6;
	}
	&:first-of-type {
		border-left: none;
	}
`;
export const HistoryContentWrapper = styled.article`
	display: flex;
	gap: 3.2rem;
	width: 100%;
	@media screen and (max-width: 1370px) {
		padding: 0 2rem;
	}
	@media screen and (max-width: 900px) {
		flex-direction: column;
	}
`;
export const HistoryImgBox = styled.article<{ bgImg: string }>`
	max-width: 40rem;
	width: 100%;
	height: 28rem;
	background-image: url(${(props) => props.bgImg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;
export const HistoryContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	width: 100%;
`;

export const HistoryContentMainTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.size6xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: ${(props) => props.theme.colors.primary400};
	padding: 2rem 0;
	border-bottom: 1px solid #adb5bd;
`;

export const HistoryContentTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const HistoryContentItemBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
`;
export const HistoryContentItem = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
`;
export const HistoryContentSubTitle = styled.div`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const HistoryContentDescription = styled.li`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	/* color: #212529;
	list-style-type: disc;
	list-style-position: inside; */
	position: relative;
	padding-left: 0.8rem;
	&::after {
		content: '';
		position: absolute;
		top: calc(0.8em - 3px);
		left: 0;
		background-color: currentColor;
		width: 4px;
		height: 4px;
		border-radius: 50%;
	}
`;
